import React, { useState } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Button,
    Row,
    Col,
    Badge,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap";
import classnames from "classnames";
import { FaPhone, FaCheckCircle, FaMapMarkerAlt, FaRegBuilding, FaTags, FaClock, FaSearch } from "react-icons/fa";
import logo1 from '../../../src/assets/images/1505751_LogoR_75_75.jpg';
import agentDefault from "../../../src/assets/images/defaultagent.png";
import { Link } from "react-router-dom";

const AgentCard = ({ agent }) => (
    <Card className="mb-4 shadow-lg border-0 bg-white" style={{ borderRadius: '1rem' }}>
        <CardBody className="p-4">
            <Row>
                <Col xs="12" md="2" className="text-center mb-3 mb-md-0">
                    <img
                        src={agent.logo || agentDefault}
                        alt="Agent Logo"
                        className="rounded-circle border border-2"
                        style={{ width: "90px", height: "90px", objectFit: "cover" }}
                    />
                </Col>
                <Col xs="12" md="10">
                    <div className="d-flex justify-content-between align-items-start flex-wrap">
                        <div>
                            <CardTitle tag="h4" className="mb-1 text-dark fw-bold">{agent.name}</CardTitle>
                            <p className="text-muted mb-2">Contact Person: <strong>{agent.contact}</strong></p>
                        </div>
                        <div>
                            <Badge color="success" className="me-2">
                                <FaCheckCircle className="me-1" /> Certified
                            </Badge>
                            <Badge color="info">Top Rated</Badge>
                        </div>
                    </div>

                    <Row className="text-muted small mb-2">
                        <Col md="6" className="mb-2">
                            <FaMapMarkerAlt className="me-2 text-primary" />{agent.address}
                        </Col>
                        <Col md="6" className="mb-2">
                            <FaTags className="me-2 text-warning" />Price: {agent.priceRange}
                        </Col>
                    </Row>

                    <Row className="text-muted small mb-2">
                        <Col md="6" className="mb-2">
                            <FaRegBuilding className="me-2 text-success" />Dealing In: {agent.areas}
                        </Col>
                        <Col md="6" className="mb-2">
                            <FaRegBuilding className="me-2 text-danger" />Properties: {agent.properties}
                        </Col>
                    </Row>
                    <p className="text-muted small mb-3">
                        <FaClock className="me-2 text-secondary" />Operating Since: {agent.since}
                    </p>
                    <Row>
                        <Col xs="6" sm="3" className="mb-2">
                            <Button color="danger"
                                style={{
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }} className="w-100">
                                Contact Agent
                            </Button>
                        </Col>
                        <Col xs="6" sm="3" className="mb-2">
                            <Button
                                tag={Link}
                                to={`/agents/Details/${agent.title}`}
                                color="danger"
                                className="px-4 py-2"
                                style={{
                                    borderRadius: '50px',
                                    fontWeight: '700',
                                    fontSize: '16px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    boxShadow: '0 4px 8px rgba(220, 53, 69, 0.3)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                View Details
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </CardBody>
    </Card>
);
const Agents = () => {
    const [activeTab, setActiveTab] = useState("1");
    const [searchQuery, setSearchQuery] = useState("");

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const dummyAgents = [
        {
            name: "Sunfin Realty Pvt. Ltd.",
            contact: "Mahesh",
            logo: logo1,
            areas: "Gotri, Akota, Alkapuri",
            properties: "64 Flats | 21 Houses | 14 Offices | 7 Villas",
            address: "RC Dutt Road, Vadodara",
            priceRange: "₹26 Lac to 3.21 Cr",
            since: "2009",
            title: "Mahesh-Sunfin-Realty"
        },
        {
            name: "Kalpana Property",
            contact: "Kamlesh Patil",
            logo: agentDefault,
            areas: "Manjalpur, Waghodia Road",
            properties: "40 Flats | 10 Houses | 5 Offices",
            address: "Vasna Road, Vadodara",
            priceRange: "₹20 Lac to 2.5 Cr",
            since: "2015",
            title: "Kalpana-Patil-Kalpana-Property"
        },
        {
            name: "Dream Home Estates",
            contact: "Priya Shah",
            logo: agentDefault,
            areas: "Alkapuri, Karelibaug",
            properties: "50 Flats | 15 Villas",
            address: "Ellora Park, Vadodara",
            priceRange: "₹30 Lac to 3 Cr",
            since: "2012",
            title: "Priya-Shah-Dream-Home"
        },
        {
            name: "UrbanNest Realty",
            contact: "Rakesh Patel",
            logo: agentDefault,
            areas: "New Alkapuri, Tarsali",
            properties: "70 Flats | 25 Houses",
            address: "Tarsali Ring Road, Vadodara",
            priceRange: "₹35 Lac to 4 Cr",
            since: "2010",
            title: "Rakesh-Patel-UrbanNest"
        }
    ];

    const filteredAgents = dummyAgents.filter(agent => {
        const searchLower = searchQuery.toLowerCase();
        return (
            agent.name.toLowerCase().includes(searchLower) ||
            agent.contact.toLowerCase().includes(searchLower) ||
            agent.areas.toLowerCase().includes(searchLower) ||
            agent.address.toLowerCase().includes(searchLower)
        );
    });

    return (
        <div style={{ paddingTop: '125px' }}> {/* Added padding instead of multiple br tags */}
            <div className="container py-4">
                <h2 className="mb-4 fw-bold text-center text-white">Top Property Dealers in Vadodara</h2>

                {/* Search Bar */}
                <div className="w-100 mb-4" style={{ position: "relative", maxWidth: '600px', margin: '0 auto' }}>
                    <Input
                        type="text"
                        placeholder="Search by Agent Name, Contact, or Area..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            border: "1px solid rgba(255, 215, 0, 0.4)",
                            color: "white",
                            padding: "12px 50px 12px 20px",
                            borderRadius: "30px",
                            fontSize: "1rem",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                            width: "100%",
                            height: '50px'
                        }}
                    />
                    <FaSearch
                        color="gold"
                        size={20}
                        style={{
                            position: "absolute",
                            right: "20px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                        }}
                    />
                </div>

                <Nav tabs className="mb-4 nav-tabs-custom justify-content-center">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => toggle("1")}
                            role="button"
                        >
                            Agents ({filteredAgents.length})
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => toggle("2")}
                            role="button"
                        >
                            Properties (11125)
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "3" })}
                            onClick={() => toggle("3")}
                            role="button"
                        >
                            New Projects (1130)
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        {filteredAgents.length > 0 ? (
                            filteredAgents.map((agent, index) => (
                                <AgentCard key={index} agent={agent} />
                            ))
                        ) : (
                            <p className="text-center text-white">No agents found matching your search.</p>
                        )}
                    </TabPane>
                    <TabPane tabId="2">
                        <p className="text-white">Property Listings Coming Soon...</p>
                    </TabPane>
                    <TabPane tabId="3">
                        <p className="text-white">New Projects Coming Soon...</p>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    );
};

export default Agents;